module.exports = __webpack_public_path__ + "static/taylor-stauss-b9d15461f9a64f2e0126f85a9affae6f.jpg";